const carouselItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20costume%20drama%20scene%20with%20a%20grand%20palace%20and%20two%20characters%20in%20magnificent%20traditional%20silk%20robes%20embracing%20in%20a%20courtyard%20filled%20with%20cherry%20blossoms%2C%20warm%20golden%20sunset%20light%2C%20cinematic%20wide%20shot%2C%20romantic%20atmosphere&width=800&height=420&seq=carousel-pipi-01&orientation=landscape',
    tag: '古装巨制',
    title: '长风渡：先婚后爱的绝美古装传奇',
    desc: '白敬亭与宋轶首次搭档，演绎纨绔子弟与商贾之女的先婚后爱故事。精美服化道，扣人心弦的剧情，年度必看古装剧。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dark%20intense%20crime%20drama%20scene%20with%20a%20man%20in%20police%20uniform%20confronting%20a%20powerful%20figure%20in%20a%20shadowy%20office%2C%20dramatic%20lighting%20with%20strong%20contrast%2C%20tense%20atmosphere%2C%20cinematic%20composition%2C%20film%20noir%20aesthetic&width=800&height=420&seq=carousel-pipi-02&orientation=landscape',
    tag: '现象级神作',
    title: '狂飙：国产犯罪剧天花板之作',
    desc: '张译张颂文联袂演绎二十年正邪较量，从鱼贩到黑恶势力大佬的堕落史。豆瓣高分爆款，每一帧都是演技教科书。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dreamy%20fantasy%20scene%20with%20a%20celestial%20being%20in%20flowing%20white%20robes%20standing%20on%20a%20cloud%20bridge%20made%20of%20starlight%2C%20surrounded%20by%20floating%20crystals%20and%20ethereal%20light%2C%20galaxy%20in%20the%20background%2C%20enchanting%20atmosphere&width=800&height=420&seq=carousel-pipi-03&orientation=landscape',
    tag: '仙侠新篇',
    title: '星落凝成糖：虐心仙侠美学巅峰',
    desc: '陈星旭李兰迪绝美搭档，人神之恋跨越三界。特效精良唯美，剧情反转不断，带你走进美轮美奂的仙侠世界。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Modern%20high-rise%20newsroom%20with%20a%20confident%20woman%20anchoring%20a%20live%20broadcast%2C%20multiple%20TV%20screens%20in%20background%2C%20intense%20professional%20atmosphere%2C%20warm%20studio%20lighting%2C%20urban%20skyline%20through%20glass%20walls&width=800&height=420&seq=carousel-pipi-04&orientation=landscape',
    tag: '港剧回潮',
    title: '新闻女王：佘诗曼演绎职场权谋',
    desc: '佘诗曼回归TVB巅峰之作，新闻直播间里的宫斗大戏。专业与野心交织，每集都在反转，港剧迷不可错过的年度惊喜。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Tranquil%20rural%20Chinese%20landscape%20with%20a%20traditional%20farmhouse%2C%20green%20terraced%20fields%2C%20friends%20gathering%20around%20an%20outdoor%20wooden%20table%20with%20home-cooked%20meals%2C%20warm%20sunset%20glow%2C%20nostalgic%20peaceful%20atmosphere&width=800&height=420&seq=carousel-pipi-05&orientation=landscape',
    tag: '慢综治愈',
    title: '向往的生活：温情告别慢时光',
    desc: '何炅黄磊携好友团回归田园，一屋三餐四季。没有剧本的真情流露，最治愈的下饭综艺，让忙碌的你找回生活的温度。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            编辑精选热门剧集深度推荐，发现值得追的好内容
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="sm:w-2/5 flex-shrink-0 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-48 sm:h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                <span className="inline-block text-xs px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 font-medium mb-2 whitespace-nowrap w-fit">
                  {item.tag}
                </span>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}